import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const StockAndShipping: StyleRule = ({ theme }) => ({
    fontSize: theme.siteVariables.fontSizes.caption02,
    color: '#7B7B7B', // Non standard color
});

export const Stock: StyleRule<{ showTradeOnly?: boolean }> = ({
    theme,
    showTradeOnly,
}) => ({
    color: theme.siteVariables.colors.charcoal[250],
    fontSize: pxToRem(16),
    lineHeight: pxToRem(24),
    ...theme.siteVariables.textStyles.Text.Roman55,
    [theme.screen.tablet]: {
        fontSize: pxToRem(16),
        lineHeight: theme.siteVariables.lineHeightDefault,
        maxWidth: pxToRem(369),
        marginBottom: pxToRem(showTradeOnly ? 0 : 12),
    },
});

export const Divider: StyleRule = () => ({
    marginTop: pxToRem(21),
});

export const TradeOnlyContainer: StyleRule = ({ theme }) => ({
    lineHeight: pxToRem(15),
    marginBottom: pxToRem(5),
    [theme.screen.tablet]: {
        marginTop: pxToRem(2),
        marginBottom: pxToRem(15),
    },
});
